if (!customElements.get('alwan-feature-video')) {
  customElements.define(
    'alwan-feature-video',
    class AlwanFeatureVideo extends HTMLElement {
      connectedCallback() {
        this.video = this.querySelector('video');
        this.toggle = this.querySelector('.alwan-feature-video__toggle');
        if (!this.video || !this.toggle) return;

        this.mobileQuery = window.matchMedia('(max-width: 749px)');
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.saveData = Boolean(navigator.connection && navigator.connection.saveData);
        this.userPaused = false;

        this.applySource();
        this.mobileQuery.addEventListener('change', () => this.applySource());

        this.toggle.hidden = false;
        this.toggle.addEventListener('click', () => this.onToggle());
        this.video.addEventListener('play', () => this.syncButton());
        this.video.addEventListener('pause', () => this.syncButton());

        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver((entries) => this.onIntersect(entries), { threshold: 0.5 });
          this.observer.observe(this.video);
        }
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
      }

      applySource() {
        const mobile = this.mobileQuery.matches;
        const src = mobile ? this.dataset.srcMobile : this.dataset.srcDesktop;
        const poster = mobile ? this.dataset.posterMobile : this.dataset.posterDesktop;
        if (!src || src === this.activeSrc) return;
        this.activeSrc = src;
        const wasPlaying = !this.video.paused;
        this.video.querySelectorAll('source').forEach((source) => source.remove());
        if (poster) this.video.poster = poster;
        this.video.src = src;
        if (wasPlaying) this.play();
      }

      canAutoplay() {
        return !this.reducedMotion.matches && !this.saveData && !this.userPaused;
      }

      onIntersect(entries) {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            if (this.canAutoplay()) this.play();
          } else if (!this.video.paused) {
            this.video.pause();
          }
        });
      }

      onToggle() {
        if (this.video.paused) {
          this.userPaused = false;
          this.play();
        } else {
          this.userPaused = true;
          this.video.pause();
        }
      }

      play() {
        const attempt = this.video.play();
        if (attempt && attempt.catch) attempt.catch(() => this.syncButton());
      }

      syncButton() {
        const playing = !this.video.paused;
        this.toggle.setAttribute('aria-pressed', String(playing));
        this.toggle.setAttribute('aria-label', playing ? this.toggle.dataset.labelPause : this.toggle.dataset.labelPlay);
      }
    }
  );
}
